/**
 * A tiny module-level handle on the live MapLibre map.
 *
 * Most of the app reaches the map through the React ref inside MapView, but a few
 * bolt-ons (like the feedback screenshot) sit outside that tree and just need the
 * current map to grab a one-shot canvas capture. MapView sets this on creation
 * and clears it on teardown.
 */
import type { Map as MaplibreMap } from 'maplibre-gl';

let active: MaplibreMap | null = null;

export function setActiveMap(map: MaplibreMap | null): void {
  active = map;
}

export function getActiveMap(): MaplibreMap | null {
  return active;
}
